import { render } from "./SaveBtn.vue?vue&type=template&id=ff7c2b8c"
import script from "./SaveBtn.vue?vue&type=script&lang=js"
export * from "./SaveBtn.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xampp\\htdocs\\chandigarh\\kanda\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__